<template>
  <div>
    <div class="block-field" ref="blockEditor" >
      <template v-for="(blockItem, index) in blockList">
        <div :key="blockItem.id + '-item'" class="block-field-item">
          <el-popover
            :key="Date.now() + '-block-popover'"
            placement="bottom"
            trigger="click"
            popper-class="add-block-popover"
            >
            <div class="block-field-add-block" slot="reference" @click="addArticleBlock(index)">
              <i class="el-icon-circle-plus-outline"></i>
              <span class="block-field-add-block-text">添加</span>
            </div>
            <div class="add-block-content">
              <div @click="addTextBlock" class="add-block-content-text"></div>
              <el-upload
                :key="Date.now()"
                :show-file-list="false"
                multiple action=""
                accept="image/jpeg, image/png"
                :before-upload="beforeFileUpload"
                :http-request="uploadFile"
                :on-success="handleImageSuccess"
                :on-change="handleImageChange">
                <div class="add-block-content-picture"></div>
              </el-upload>
              <div @click="addLinkBlock" class="add-block-content-link"></div>
              <div @click="videoDialogVisible = true" class="add-block-content-qq-video"></div>
            </div>
          </el-popover>

          <div class="operation-block">
            <el-tooltip  content="上移" effect="dark" placement="top-end">
              <div class="operation-block-moveup" @click="moveUp(index)" v-if="index !== 0"></div>
            </el-tooltip>
            <el-tooltip  content="下移" effect="dark" placement="top">
              <div class="operation-block-movedown" @click="moveDown(index)" v-if="index !== blockList.length -1"></div>
            </el-tooltip>
            <el-tooltip  content="删除" effect="dark" placement="top-start">
              <div class="operation-block-delete" @click="deleteBlock(index)"></div>
            </el-tooltip>
          </div>

          <template v-if="blockItem.type === 'text'">
            <div class="block-field-item-card">
              <RichTextEditor class="editor-wrap"
                placeholder="输入文章内容"
                :key="index"
                v-model="blockItem.content"
                :maxChars="maxContentLength" />
            </div>
          </template>

          <template v-if="blockItem.type === 'image'">
            <div class="block-field-item-card">
              <div class="block-field-item-card-field">
                <viewer :images="blockItem.src" ref="viewer">
                  <template v-for="(srcItem, index) in blockItem.src">
                    <img :src="srcItem" :key="srcItem + index"
                        :data-src="srcItem.indexOf('?') === -1 ? srcItem : srcItem.split('?')[0].toString()"
                    />
                    <div :key="srcItem" class="block-field-item-card-field-caption">
                      <el-input v-model="blockItem.caption" placeholder="请输入图片描述"></el-input>
                    </div>
                  </template>
                </viewer>
              </div>
            </div>
          </template>

          <template v-if="blockItem.type === 'link'">
            <div class="block-field-item-card">
              <div class="block-field-item-card-field" @click="editLinkBlock(blockItem)" >
                <div class="link-block-field">{{blockItem.title}}</div>
              </div>
            </div>
          </template>

          <template v-if="blockItem.type === 'video'">
            <div class="block-field-item-card">
              <div class="block-field-item-card-field">
                <video-player
                  :key="blockItem.id"
                  class="vjs-mc-skin"
                  :playsinline="true"
                  :options="blockItem.playerOption"
                  ref="videoPlayer">
                </video-player>
                <div class="block-field-item-card-field-caption">
                  <el-input v-model="blockItem.caption" placeholder="请输入视频描述"></el-input>
                </div>
              </div>
            </div>
          </template>

          <template v-if="blockItem.type === 'qq-video'">
            <div class="block-field-item-card">
              <div class="block-field-item-card-field" >
                <iframe
                  frameborder="0"
                  style="width:100%; height:460px;"
                  :src= 'blockItem.videoUrl'
                  allowFullScreen="true">
                </iframe>
                <div class="block-field-item-card-field-caption">
                  <el-input v-model="blockItem.caption" placeholder="请输入腾讯视频描述"></el-input>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>

      <el-popover
        popper-class="add-block-popover"
        :key="Date.now() + 'popover'"
        placement="bottom"
        trigger="click"
        >
        <div class="block-field-add-block" slot="reference" @click="addArticleBlock(blockList.length)">
          <i class="el-icon-circle-plus-outline"></i>
          <span class="block-field-add-block-text">添加</span>
        </div>
        <div class="add-block-content">
          <div @click="addTextBlock" class="add-block-content-text"></div>
          <el-upload
            :key="Date.now()"
            :show-file-list="false"
            multiple action=""
            accept="image/jpeg, image/png"
            :before-upload="beforeFileUpload"
            :http-request="uploadFile"
            :on-success="handleImageSuccess"
            :on-change="handleImageChange">
            <div class="add-block-content-picture"></div>
          </el-upload>
          <div @click="addLinkBlock" class="add-block-content-link"></div>
          <div @click="videoDialogVisible = true" class="add-block-content-qq-video"></div>
        </div>
      </el-popover>
    </div>

    <el-dialog
      :title="linkDialogName"
      class="link-dialog"
      width="460px"
      center
      :destroy-on-close="true"
      :visible.sync="linkDialogVisible"
      @close="closeLinkDialog">
      <el-input class="link-input" placeholder="输入文本对象" v-model="linkTitle"></el-input>
      <el-input class="link-input" placeholder="输入目标链接" v-model="linkUrl"></el-input>
      <span slot="footer">
        <template v-if="editLink">
          <el-button class="article-submit-btn" type="primary" @click="editInputLink">修改</el-button>
        </template>
        <template v-else>
          <el-button class="article-submit-btn" type="primary" @click="confirmInputLink">确认</el-button>
        </template>
      </span>
    </el-dialog>

    <el-dialog
      title="添加视频"
      class="video-dialog"
      width="460px"
      center
      :destroy-on-close="true"
      :visible.sync="videoDialogVisible"
      @close="closeVideoDialog"
      >
      <el-tabs type="border-card">
        <el-tab-pane label="本地视频">
          <div class="video-dialog-content">
            <el-upload
              :data= "{type: 'video'}"
              :show-file-list="false"
              action=""
              accept="video/mp4"
              :http-request="uploadFile"
              :on-success="handleVideoSuccess"
              >
            <i class="fa fa-play-circle"></i>
            上传本地视频
            </el-upload>
          </div>
        </el-tab-pane>
        <el-tab-pane label="腾讯视频">
          <div class="qqvideo-dialog">
            <el-input class="link-input" placeholder="输入腾讯视频链接" v-model="qqVideoLinkUrl"></el-input>
            <div>
              链接获取方式：在视频播放页面依次点击"分享"-"复制页面地址"，即可复制链接到剪切板
            </div>
            <span slot="footer">
              <div class="qqvideo-dialog-footer">
                <el-button class="article-submit-btn" type="primary" @click="confirmInputQQVideoLink">确认</el-button>
              </div>
            </span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import RichTextEditor from '@/components/rich-text-editor/index';
import Viewer from 'v-viewer';
import { getFileKey, matchUrl, matchQQVideoVid } from '@/util/util';
import { getOSSSign, uploadImage } from '@/api/basic/aliyunoss';

export default {
  data() {
    return {
      blockList: [],
      blockPosition: 0,
      articleLoading: null,
      // 文本块参数设置
      maxContentLength: 5000,
      // 图片块参数设置
      uploadImageUrl: [],
      limitFilesCount: 9,
      hasShowLimitMessage: false,
      // 超链接参数设置
      linkDialogVisible: false,
      linkUrl: '',
      linkTitle: '',
      linkDialogName: '',
      editLink: false,
      editLinkItemId: -1,
      // 视频块参数设置
      videoDialogVisible: false,
      videoBlockUrl: '',
      playerOption: {
        height: '380',
        autoplay: false,
        muted: false,
        loop: false,
        language: 'zh-CN',
        playbackRates: [1.0, 1.5, 2.0],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        sources: [{
          src: '',
        }],
      },
      // 腾讯视频参数设置
      qqVideoLinkUrl: '',
    };
  },
  props: {
    value: {
      type: Array,
    },
    contentList: {
      type: Array,
    },
  },
  components: {
    RichTextEditor,
  },
  methods: {
    initHandleData() {
      if (this.contentList) {
        this.blockList = JSON.parse(JSON.stringify(this.contentList));
        this.blockList.forEach((item, index) => {
          this.$set(item, 'id', index);
          if (item.type === 'video') {
            const articleVideoPlayerOption = JSON.parse(JSON.stringify(this.playerOption));
            articleVideoPlayerOption.sources[0].src = item.src;
            this.$set(item, 'playerOption', articleVideoPlayerOption);
          }
          if (item.type === 'image') {
            item.src = [`${item.src}?x-oss-process=image/resize,w_900`];
          }
          if (item.type === 'qq-video') {
            item.videoUrl = `https://v.qq.com/txp/iframe/player.html?vid=${item.vid}`;
          }
        });
      }
    },
    addTextBlock() {
      const textContent = {
        id: this.blockList.length,
        type: 'text',
        content: '',
      };
      this.blockList.splice(this.blockPosition, 0, textContent);
    },
    addLinkBlock() {
      this.linkDialogName = '添加超链接';
      this.linkDialogVisible = true;
    },
    editLinkBlock(item) {
      this.linkDialogName = '编辑超链接';
      this.linkDialogVisible = true;
      this.linkTitle = item.title;
      this.linkUrl = item.href;
      this.editLink = true;
      this.editLinkItemId = item.id;
    },
    deleteBlock(index) {
      this.blockList.splice(index, 1);
    },
    beforeFileUpload(file) {
      let suffix = '';
      const imageType = file.type ? file.type.toLowerCase() : '';
      if (imageType === 'image/jpeg') {
        suffix = '.jpg';
      } else if (imageType === 'image/png') {
        suffix = '.png';
      } else {
        this.$message.error('仅支持jpg、png格式');
        return false;
      }
      if (file.limitExceeded) {
        if (!this.hasShowLimitMessage) {
          this.hasShowLimitMessage = true;
          this.$message({
            showClose: true,
            message: '一次最多可选择 9 张图片',
            type: 'warning',
          });
        }
        return false;
      }
      return true;
    },
    handleImageChange(file, fileList) {
      console.log('handleImageChange', file);
      file.raw.limitExceeded = false;
      if (file.status === 'ready' && fileList.length > this.limitFilesCount) {
        file.raw.limitExceeded = true;
      }
    },
    uploadFile(option) {
      // 设置视频的dialog为false, 是因为当上传文件太大的时候，在上传成功之前会一直存在此dialog。
      this.videoDialogVisible = false;
      // 获取文件路径名
      getFileKey(option.file, (fileKey) => {
        if (!this.articleLoading) {
          this.articleLoading = this.$loading({target: this.$refs.blockEditor});
        }
        // 获取阿里云签名
        getOSSSign().then(response => {
          let cdnHost = response.data.data.cdnHost
          let host = response.data.data.host;
          let params = new FormData();
          params.append('name', option.file.name)
          params.append('key', fileKey)
          params.append('policy', response.data.data.policy)
          params.append('OSSAccessKeyId', response.data.data.accessKeyId)
          params.append('success_action_status', 200)
          params.append('signature', response.data.data.signature)
          params.append('file', option.file, option.file.name)
          uploadImage(host, params).then(response => {
            if (option.data && option.data.type === 'video') {
              this.videoBlockUrl = `${cdnHost}/${fileKey}`;
            } else {
              this.uploadImageUrl.push(`${cdnHost}/${fileKey}?x-oss-process=image/resize,w_900`);
            }
            option.onSuccess(response);
          }).catch(error => {
            this.$message({
              message: '上传失败',
              type: 'error'
            });
            console.log('uploadImageError', error);
            option.onError(error);
          }).finally(() => {
            if (this.articleLoading) {
              this.articleLoading.close();
              this.articleLoading = null;
            }
          });
        }).catch((error) => {
          this.$message({
            showClose: true,
            message: '图片上传失败',
            type: 'error',
          });
          console.log('getOSSSign', error);
          if (this.articleLoading) {
            this.articleLoading.close();
            this.articleLoading = null;
          }
          option.onError(error);
        });
      })
    },
    handleImageSuccess() {
      for (let i = 0; i < this.uploadImageUrl.length; i += 1) {
        const imageUrl = this.uploadImageUrl[i];
        const imageBlockItem = {
          id: this.blockList.length,
          type: 'image',
          src: [imageUrl],
          caption: '',
        };
        this.blockList.splice(this.blockPosition, 0, imageBlockItem);
        this.blockPosition += 1;
      }
      this.uploadImageUrl = [];
      this.hasShowLimitMessage = false;
    },
    preSubmitLink() {
      const isCorrectUrl = matchUrl(this.linkUrl);
      if (!isCorrectUrl) {
        this.$message({
          showClose: true,
          message: '请输入正确的链接地址',
          type: 'error',
        });
        this.linkUrl = '';
        return false;
      }
      return true;
    },
    confirmInputLink() {
      if (!this.preSubmitLink()) {
        return;
      }
      const linkContent = {
        id: this.blockList.length,
        type: 'link',
        href: this.linkUrl,
        title: this.linkTitle,
      };
      this.blockList.splice(this.blockPosition, 0, linkContent);
      this.linkUrl = '';
      this.linkTitle = '';
      this.linkDialogVisible = false;
    },
    editInputLink() {
      if (!this.preSubmitLink()) {
        return;
      }
      this.blockList.forEach((item) => {
        if (item.type === 'link' && item.id === this.editLinkItemId) {
          item.href = this.linkUrl;
          item.title = this.linkTitle;
        }
      });
      this.linkUrl = '';
      this.linkTitle = '';
      this.linkDialogVisible = false;
      this.editLink = false;
    },
    closeLinkDialog() {
      this.linkUrl = '';
      this.linkTitle = '';
      this.linkDialogVisible = false;
      this.editLink = false;
    },
    confirmInputQQVideoLink() {
      const qqVid = matchQQVideoVid(this.qqVideoLinkUrl);
      if (!qqVid) {
        this.$message({
          showClose: true,
          message: '请输入正确的视频链接',
          type: 'error',
        });
        return;
      }
      const qqVideoItem = {
        id: this.blockList.length,
        type: 'qq-video',
        vid: qqVid,
        src: this.qqVideoLinkUrl,
        videoUrl: `https://v.qq.com/txp/iframe/player.html?vid=${qqVid}`,
        caption: '',
      };
      this.blockList.splice(this.blockPosition, 0, qqVideoItem);
      this.qqVideoLinkUrl = '';
      this.videoDialogVisible = false;
    },
    closeVideoDialog() {
      this.qqVideoLinkUrl = '';
      this.videoDialogVisible = false;
    },
    addArticleBlock(index) {
      this.blockPosition = index;
    },
    moveUp(index) {
      if (index === 0) {
        this.$message({
          showClose: true,
          message: '当前模块已处于顶部',
          type: 'error',
        });
      } else {
        this.blockList[index] = this.blockList.splice(index - 1, 1, this.blockList[index])[0];
      }
    },
    moveDown(index) {
      if (index === this.blockList.length - 1) {
        this.$message({
          showClose: true,
          message: '当前模块已处于底部',
          type: 'error',
        });
      } else {
        this.blockList[index] = this.blockList.splice(index + 1, 1, this.blockList[index])[0];
      }
    },
    handleVideoSuccess() {
      const videoPlayerOption = JSON.parse(JSON.stringify(this.playerOption));
      videoPlayerOption.sources[0].src = this.videoBlockUrl;
      const videoItem = {
        id: this.blockList.length,
        type: 'video',
        src: this.videoBlockUrl,
        caption: '',
        playerOption: videoPlayerOption,
      };
      this.blockList.splice(this.blockPosition, 0, videoItem);
      this.videoDialogVisible = false;
    },
  },
  watch: {
    contentList: {
      handler() {
        this.initHandleData();
      },
      immediate: true,
    },
    blockList: {
      handler() {
        this.$emit('input', this.blockList);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .block-field {
    padding: 0px 20px;
    &-add-block {
      cursor: pointer;
      text-align: center;
      color: #666666;
      width: 120px;
      margin: 10px 0px 10px 410px;
      background: #eeeeee;
      border-radius: 30px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      i {
        padding: 10px 5px;
        font-size: 25px;
      }
      &-text {
        font-size: 14px;
        line-height: 45px;
      }
    }
    &-add-block:hover {
      color: #e27b48;
    }
    &-item {
      position: relative;
      &-card {
        width: 100%;
        &-field {
          text-align: center;
          /deep/.el-input__inner {
            text-align: center;
          }
          &-caption {
            margin: 10px 0px 0px 0px;
          }
          .link-block-field {
            border: 1px solid #eeeeee;
            height: 60px;
            font-size: 22px;
            line-height: 60px;
            text-align: left;
            cursor: pointer;
            border-radius: 5px;
            padding-left: 15px;
          }
        }
      }
      .operation-block {
        position: absolute;
        right: 10px;
        top: 5px;
        z-index: 10;
        visibility: hidden;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        /deep/ .operation-block-moveup, /deep/ .operation-block-movedown, /deep/.operation-block-delete {
          width: 40px;
          height: 40px;
          margin: 0px 8px;
        }
        /deep/ .operation-block-moveup {
          background:url("../../static/images/editor/moveup.svg") no-repeat;
          background-size: 40px;
        }
        /deep/ .operation-block-movedown {
          background:url("../../static/images/editor/movedown.svg") no-repeat;
          background-size: 40px;
        }
        /deep/.operation-block-delete {
          background:url("../../static/images/editor/delete.svg") no-repeat;
          background-size: 40px;
        }
        /deep/ .operation-block-moveup:hover {
          background:url("../../static/images/editor/moveup-hover.svg") no-repeat;
          background-size: 40px;
        }
        /deep/ .operation-block-movedown:hover {
          background:url("../../static/images/editor/movedown-hover.svg") no-repeat;
          background-size: 40px;
        }
        /deep/.operation-block-delete:hover {
          background:url("../../static/images/editor/delete-hover.svg") no-repeat;
          background-size: 40px;
        }
      }
    }
    &-item:hover .operation-block {
      visibility: visible;
    }
  }
  .link-dialog {
    .link-input {
      width: 420px;
      margin: 5px 0;
    }
    /deep/.el-dialog__footer {
      text-align: center;
      border-top: 1px solid #eeeeee;
      padding: 6px 0px;
    }
  }
  .qqvideo-dialog {
    text-align: center;
    align-items: center;
    .link-input {
      font-size: 14px;
      width: 100%;
      margin: 5px 0;
    }
    div {
      text-align: left;
      font-size: 12px;
    }
    .qqvideo-dialog-footer {
      text-align: center;
      border-top: 1px solid #eeeeee;
      margin: 20px -15px 0px -15px;
    }
  }
  .video-dialog {
    text-align: center;
    align-items: center;
    color: #0a84e1;
    .video-dialog-content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      color: #0a84e1;
      margin: 20px 0px;
    }
  }
  .article-submit-btn {
    margin: 10px 0px;
  }
  /deep/.el-popover {
    padding: 0px !important;
  }
  .add-block-popover {
    width: 226px;
    .add-block-content {
      display: flex;
      flex-direction: row;
      &-text,&-picture,&-link,&-qq-video{
        cursor: pointer;
        margin: 0px 15px;
        width: 24px;
        height: 52px;
        background-size: 24px;
      }
      &-text {
        background:url("../../static/images/editor/text.svg") no-repeat center;
      }
      &-text:hover {
        background: url("../../static/images/editor/text-hover.svg") no-repeat center;
      }
      &-picture {
        background:url("../../static/images/editor/picture.svg") no-repeat center;
      }
      &-picture:hover {
        background: url("../../static/images/editor/picture-hover.svg") no-repeat center;
      }
      &-link {
        background:url("../../static/images/editor/link.svg") no-repeat center;
      }
      &-link:hover {
        background: url("../../static/images/editor/link-hover.svg") no-repeat center;
      }
      &-qq-video {
        background:url("../../static/images/editor/video.svg") no-repeat center;
      }
      &-qq-video:hover {
        background: url("../../static/images/editor/video-hover.svg") no-repeat center;
      }
    }
}
</style>
<style lang="scss">
.el-popover {
  padding: 0px;
  line-height: 1;
}
</style>
